import { render, staticRenderFns } from "./ObjectiveEffectsActions.vue?vue&type=template&id=73ff2f1c&scoped=true&"
import script from "./ObjectiveEffectsActions.vue?vue&type=script&lang=js&"
export * from "./ObjectiveEffectsActions.vue?vue&type=script&lang=js&"
import style0 from "./ObjectiveEffectsActions.vue?vue&type=style&index=0&id=73ff2f1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ff2f1c",
  null
  
)

export default component.exports